import React from 'react';
import { subjects } from '../../data/mockData';
import { Calculator, Atom, FlaskConical, Microscope, BookOpen, Laptop, Landmark, Globe } from 'lucide-react';
import { useNavigate } from 'react-router-dom';

const iconMap = {
  Calculator,
  Atom,
  FlaskConical,
  Microscope,
  BookOpen,
  Laptop,
  Landmark,
  Globe
};

export const SubjectCategories = () => {
  const navigate = useNavigate();

  return (
    <div className="py-20 bg-gray-50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Section Header */}
        <div className="text-center mb-16">
          <h2 className="text-3xl sm:text-4xl font-bold text-gray-900 mb-4">
            Popular Subjects
          </h2>
          <p className="text-lg text-gray-600 max-w-2xl mx-auto">
            Choose from a wide range of subjects taught by expert tutors
          </p>
        </div>

        {/* Subjects Grid */}
        <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-6">
          {subjects.map((subject) => {
            const Icon = iconMap[subject.icon];
            return (
              <div
                key={subject.id}
                onClick={() => navigate(`/find-tutor?subject=${subject.name}`)}
                className="group bg-white p-6 rounded-xl shadow-sm hover:shadow-xl transition-all cursor-pointer border border-gray-100 hover:border-blue-300"
              >
                <div className={`${subject.color} w-14 h-14 rounded-lg flex items-center justify-center mb-4 group-hover:scale-110 transition-transform`}>
                  <Icon className="h-7 w-7 text-white" />
                </div>
                <h3 className="text-lg font-bold text-gray-900 mb-1">
                  {subject.name}
                </h3>
                <p className="text-sm text-gray-600">
                  {subject.tutors} tutors available
                </p>
              </div>
            );
          })}
        </div>
      </div>
    </div>
  );
};
